import React from 'react';
import { useAuth } from '@/App';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, Compass } from 'lucide-react';

export default function Navigation() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white border-b border-slate-200 fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-8">
            <div 
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-2 cursor-pointer"
            >
              <Compass className="w-8 h-8 text-black" strokeWidth={2.25} />
              <span className="text-xl font-bold tracking-tight" style={{fontFamily: 'Outfit'}}>All Build Consult</span>
            </div>
            
            <div className="hidden md:flex gap-6">
              <button
                data-testid="nav-about-link"
                onClick={() => navigate('/about')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                About
              </button>
              <button
                onClick={() => navigate('/services')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Services
              </button>
              <button
                onClick={() => navigate('/consultants')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Consultants
              </button>
              <button
                onClick={() => navigate('/bookings')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Bookings
              </button>
              <button
                data-testid="nav-reports-link"
                onClick={() => navigate('/reports')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Reports
              </button>
              <button
                data-testid="nav-payments-link"
                onClick={() => navigate('/payments')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Payments
              </button>
              <button
                onClick={() => navigate('/dashboard')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Dashboard
              </button>
              <button
                data-testid="nav-feedback-link"
                onClick={() => navigate('/feedback')}
                className="text-sm text-slate-700 hover:text-black transition-colors"
              >
                Feedback
              </button>
              {user?.role === 'admin' && (
                <button
                  data-testid="admin-dashboard-link"
                  onClick={() => navigate('/admin')}
                  className="text-sm text-black hover:text-blue-600 transition-colors font-semibold"
                >
                  Admin
                </button>
              )}
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-sm">
              <User className="w-4 h-4 text-slate-600" />
              <span className="text-sm font-medium text-black">{user?.name}</span>
              <span className="text-xs text-slate-500 ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 rounded">
                {user?.role}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 text-slate-600 hover:text-black hover:bg-slate-100 rounded-sm transition-all"
              title="Logout"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}